// src/styles/MiPDFStyles.js

const styles = {
  container: {
    backgroundColor: "#E6E6E6", // Mantiene fondo neutro claro
    minHeight: "100vh",
    padding: "20px",
    textAlign: "center",
    color: "#505259", // Gris corporativo de Colbún
  },
  button: {
    backgroundColor: "#3C6CB1", // Azul corporativo (PANTONE 285 C)
    color: "#FFFFFF",
    border: "none",
    padding: "10px 16px",
    margin: "0 8px",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  buttonZoomIn: {
    backgroundColor: "#8CB740", // Verde corporativo (PANTONE 368 C)
  },
  buttonContainer: {
    marginBottom: "20px",
  },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};

export default styles;
